module.exports = __webpack_public_path__ + "img/18_pc.16c9f19a.gif";